import constants from '../constants/actionTypes'

var initialState = {
    loggedIn: localStorage.getItem('token') ? true : false,
    email: localStorage.getItem('email') ? localStorage.getItem('email') : '',
    id: localStorage.getItem('id') ? localStorage.getItem('email') : '',
    admin: localStorage.getItem('admin') || '',
    auth_form:{
      email:'',
      login:'',
      password:''
    },
    auth_result: {
      success: false,
      text: null,
      expired: false,
    },
    auth_link: null
}

export default (state = initialState, action) => {
  var updated = Object.assign({}, state)

  switch(action.type) {
    case constants.LOGOUT_SUCCESS:
      updated['loggedIn'] = false;
      updated['auth_result']['success'] = false;
      updated['auth_result']['text'] = '';
      return updated;

    case constants.AUTH_FORM_CHANGE:
      updated['auth_form'] = action.payload
      return updated

    case constants.AUTH_FORM_SUBMIT_START:
      return updated    

    case constants.AUTH_FORM_SUBMIT_SUCCESS:
      updated['auth_link'] = action.payload
      return updated  

    case constants.AUTH_FORM_SUBMIT_ERROR:
      updated['loggedIn'] = false;
      updated['auth_result']['success'] = false;
      updated['auth_result']['text'] = action.payload;
      return updated  
 
    case constants.LOGIN_ERROR:
      updated['auth_result']['success'] = false;
      updated['auth_result']['text'] = action.payload;
      return updated   

    case constants.LOGIN_SUCCESS:
      updated['loggedIn'] = true;
      updated['email'] = action.payload.email;
      updated['auth_result']['success'] = true;
      updated['auth_result']['text'] = action.payload.email;
      updated['admin'] = action.payload.admin;
      return updated;      

    case constants.AUTH_CHECK_START:
      return updated;  

    case constants.AUTH_CHECK_ERROR:
      return updated;  

    case constants.AUTH_CHECK_SUCCESS:
      return updated; 

    default:
      return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js